import { CurrenciesMetaReducer } from 'components/features/rewards/rewardsPane/types/store'
import { createAction } from 'helpers/actionHelpers/createAction'
import { createRequestAction } from 'helpers/actionHelpers/createRequestAction'
import { CryptoRewardsCurrenciesListResponse } from 'components/features/rewards/rewardsPane/types/apiResponses'

type CurrenciesMetaReducerChangeStateActionPayload = Partial<CurrenciesMetaReducer>

export class CurrenciesMetaReducerChangeStateAction extends (
  createAction<'CURRENCIES_META_REDUCER_CHANGE_STATE', CurrenciesMetaReducerChangeStateActionPayload>('CURRENCIES_META_REDUCER_CHANGE_STATE')
) {}

type CurrenciesMetaReducerUpsertMetaStateActionPayload = CurrenciesMetaReducer['currenciesMeta']

export class CurrenciesMetaReducerUpsertMetaStateAction extends (
  createAction<'CURRENCIES_META_REDUCER_UPSERT_META_STATE', CurrenciesMetaReducerUpsertMetaStateActionPayload>('CURRENCIES_META_REDUCER_UPSERT_META_STATE')
) {}

export class CurrenciesMetaGetMetaInfoRequestAction extends (
  createRequestAction<'API_REQUEST_GET_CURRENCIES_META_INFO', void, CryptoRewardsCurrenciesListResponse['items']>('API_REQUEST_GET_CURRENCIES_META_INFO')
) {}

export type CurrenciesMetaReducerActions =
  | CurrenciesMetaReducerChangeStateAction
  | CurrenciesMetaReducerUpsertMetaStateAction
  | typeof CurrenciesMetaGetMetaInfoRequestAction.Type
